<template>
  <v-dialog v-model="dialogDettaglioDocumento" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark :color="colorModalita" dense>
        <v-btn icon dark @click="closeDialogDocumento">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{dialogTitle}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="closeDialogDocumento">
            Chiudi
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>     
      <body-documento :locDocumento="locDocumento" :trigger="trigger" :readOnly="solaLettura" @nuovaRiga="onNuovaRiga" @updateTotali="trigger++" @mostraParcheggio="onMostraParcheggio" @move="spostaRiga" ref="bodyDocumento"/>
      <v-alert v-model="datiNonCompleti" dismissible prominent dense type="error">Non sono stati inseriti tutti i dati necessari</v-alert>
      <v-card-actions>
        <v-row align="center" justify="end">
          <!-- <v-btn color="info" class="mt-3 mr-5" @click="stampaDocumento">Stampa documento</v-btn> -->
          <v-btn color="success" class="mt-3 mr-5" :disabled="salvataggioInCorso || creazioneInCorso || creazioneDisabled || solaLettura" @click="creaOrdiniFornitore">Crea ordini fornitore</v-btn>
          <v-btn color="primary" class="mt-3 mr-5 ml-5" :disabled="salvataggioInCorso || saveDisabled" @click="salvaDocumento">Salva documento</v-btn>
          <!-- <v-btn color="success" v-if="hasXml" class="mt-3 mr-5" :disabled="saveDisabled" @click="salvaXML">Salva e crea XML</v-btn> -->
        </v-row>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="dialogCloseConfirm" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Confermi chiusura senza salvataggio ?</v-card-title>
        <v-card-text>Il documento potrebbe non essere stato salvato</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeConfirm">SI</v-btn>
          <v-btn color="blue darken-1" text @click="cancelClose">NO</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCreaOrdiniConfirm" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Confermi creazione ordini ai fornitori ?</v-card-title>
        <v-card-text>
          Verrà generato un ordine per ciascun fornitore.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="creaConfirm">SI</v-btn>
          <v-btn color="blue darken-1" text @click="creaCancel">NO</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-alert :value="ordiniCreati" dismissible prominent dense type="info">Sono stati creati gli ordini: {{ elencoOrdiniCreati }}</v-alert>    
  </v-dialog>
</template>

<script>
  import { downloadXml, getAnnoRiferimento } from '@/components/helpers.js'
  import errorService from '@/services/errorService'
  import { printed } from '@/helpers/printed.js'
  import xml7 from '@/services/xml7Service.js'
  import BodyDocumento from './bodyTable.vue'
  import documenti from '@/services/documentiService.js'
  import clienti from '@/services/clientiService.js'
  import movimenti from '@/services/movimentiService.js'
  import magazzino from '@/services/magazzinoService.js'
  import configurazioni from '@/services/configurazioniService.js'
  import reporting from '@/services/reportingService.js'

  export default {
    components: {
      BodyDocumento
    },
    props: {
      showDialog: { type: Boolean, default: false },
      idDocumento: { type: String, default: '' },
      nuovoDocumento: Boolean,
      readOnly: Boolean,
      filtraTipiDocumento: Array
    },
    data () {
      return {
        locDocumento: {model: '', generale: '', source: ''},
        dialogDettaglioDocumento: false,
        trigger: 1,
        triggerLocale: 1,
        daSalvare: false,
        mostraParcheggio: false,
        dialogCloseConfirm: false,
        tipoDocumento: null,
        forzaTipo: null,
        datiNonCompleti: false,
        salvataggioInCorso: false,
        creazioneInCorso: false,
        creazioneDisabled: false,
        dialogCreaOrdiniConfirm: false,
        statoNullo: { codice: '', descrizione: '' },
        ddtChiuso: false,
        ordiniCreati: false,
        elencoOrdiniCreati: ''
      }
    },
    beforeMount() {
      window.addEventListener("beforeunload", this.preventNav)
    },
    beforeDestroy() {
      window.removeEventListener("beforeunload", this.preventNav);
    },    
    async mounted() {
      if (this.idDocumento) {
        this.locDocumento = await documenti.getDocumento(this.idDocumento)
        this.completaAppoggio()
      } else {
        this.locDocumento = await documenti.getModello('xxx')
        this.completaAppoggio()
        this.locDocumento.data = new Date()
      }
      this.tipoDocumento = await(this.getTipo('ordineMultiplo'))
      this.dialogDettaglioDocumento = this.showDialog
    },
    watch: {
      async showDialog(value) {
        if (value) {
          await this.refresh()
          setTimeout(async () => {
            const tipi = await configurazioni.getConfigurazione('documenti_parametri', 'tipiDocumento')
            const tipoDocumento = tipi.find(x => x.tipoDocumento === 'ordineMultiplo')
            this.forzaTipoDoc(tipoDocumento)
          } , 300)          
        }
      },
      trigger() {
        this.daSalvare = true
      }
/*       triggerLocale() {
        this.daSalvare = true
      }   */    
    },
    computed: {
      dialogTitle() {
        return this.idDocumento ? `Ordine Multiplo nr. ${this.idDocumento} ${this.solaLettura ? ' (sola lettura)' : ''}` : 'Nuovo documento multiplo'
        // return 'Nuovo documento multiplo'
      },
      colorModalita() {
        return this.nuovoDocumento ? 'orange darken-1' : 'deep-orange darken-1'
      },
      saveDisabled() {
        if (this.solaLettura) return true
        // return this.trigger && this.triggerLocale && this.locDocumento && this.locDocumento.totali && this.locDocumento.totali.generale ? (this.locDocumento.totali.generale.quantita === 0 || !this.daSalvare) : true
        return !this.daSalvare
      },
      hasXml() {
        return this.trigger && this.triggerLocale && _.get(this.locDocumento, 'tipoDocumento.xml', false)
      },
      solaLettura() {
        return this.readOnly || this.ddtChiuso
      }
    },
    methods: {
      forzaTipoDoc(tipo) {
        let payload = null
        try {
          payload = _.omit(this.locDocumento.appoggio.tipoDocumento, Object.keys(tipo))
        } catch {}
        this.locDocumento.appoggio.tipoDocumento = tipo
        this.locDocumento.appoggio.clienteVisibile = _.get(tipo, 'visualizzaCliente', false)
        this.locDocumento.appoggio.fornitoreVisibile = _.get(tipo, 'visualizzaFornitore', false)
        this.locDocumento.appoggio.spedizioneVisibile = _.get(tipo, 'infoSpedizione', false)
        this.locDocumento.appoggio.pagamentoVisibile = _.get(tipo, 'infoPagamento', false)
        this.locDocumento.tipoDocumento = tipo
        if (payload) {
          this.locDocumento.appoggio.tipoDocumento = {...this.locDocumento.appoggio.tipoDocumento, ...payload}
          this.locDocumento.tipoDocumento = {...this.locDocumento.tipoDocumento, ...payload}
        }
        this.updateTrigger++
      },
      async getTipo(tipo) {
        const tipi = await configurazioni.getConfigurazione('documenti_parametri', 'tipiDocumento')
        const tipoOrdine = tipi.find(x => x.codice === tipo)
        return tipoOrdine
      },
      preventNav(event) {
        if (!this.dialogDettaglioDocumento) return
        event.preventDefault()
        event.returnValue = ""
      },      
      onMostraParcheggio(value) {
        this.mostraParcheggio = value
      },
      spostaRiga(da, a) {
        let righe = this.locDocumento.righe
        let daSpostare = JSON.parse(JSON.stringify(righe[da]))
        righe.splice(da, 1)
        if (a === -1) {
          righe.push(daSpostare)
        } else {
          righe.splice(a, 0, daSpostare)
        }
        this.trigger++
      },      
      async onNuovaRiga(riga) {
        this.locDocumento.righe.push(riga)
        this.trigger++
      },
      async refresh() {
        this.dialogDettaglioDocumento = true
        if (this.idDocumento) {
          this.locDocumento = await documenti.getDocumento(this.idDocumento)
          this.completaAppoggio()
        } else {
          this.locDocumento = await documenti.getModello('xxx')
          this.completaAppoggio()
          this.locDocumento.data = new Date()
        }
        this.ddtChiuso = ['chiuso', 'ordiniCreati'].includes(_.get(this.locDocumento, 'stato.codice', ''))
        this.trigger++
      },
      completaAppoggio() {
        let itm = this.locDocumento
        _.set(itm,'appoggio.clienteVisibile', false)
        _.set(itm,'appoggio.fornitoreVisibile', true)
        // _.set(itm,'appoggio.spedizioneVisibile', itm.tipoDocumento && itm.tipoDocumento.infoSpedizione)
        // _.set(itm,'appoggio.pagamentoVisibile', itm.tipoDocumento && itm.tipoDocumento.infoPagamento)
        _.set(itm,'appoggio.tipoDocumento', itm.tipoDocumento)
        // const clifor = _.get(itm, 'anagrafica.cliente', '') || _.get(itm, 'anagrafica.fornitore', '')
        // _.set(itm,'appoggio.clifor', clifor)
      },
      async aggiornaDocumento(documento) {
        Object.assign(this.locDocumento, documento)
        this.completaAppoggio()
        this.trigger++
      },
      async generaXmlItem(itemId) {
        const documento = await documenti.getDocumento(itemId)
        if (documento) {
          const { fattura, nomeFile, xml7File } = await xml7.creaXml7Fattura(documento)
          downloadXml(document, nomeFile, xml7File)
        }
      },
      async stampaDocumento() {
        let item = this.locDocumento
        try {
          const result = await reporting.stampaDocumento(this.$router, item, true, true)
          if (result && result.error) {
            errorService.onError(JSON.stringify(result.error))
          } else {
            await printed(item._id)
          }
        } catch {}
      },      
      async salvaDocumento() {
        this.salvataggioInCorso = true
        await this.$nextTick()
        const bodyDocumento = this.$refs.bodyDocumento
        // const headerDocumento = this.$refs.headerDocumento
        // const footerDocumento = this.$refs.footerDocumento
        let datiOk = bodyDocumento.datiCompleti()
        // datiOk = datiOk && headerDocumento.datiCompleti()
        // datiOk = datiOk && footerDocumento.datiCompleti()
        this.datiNonCompleti = !datiOk
        if (!datiOk) {
          this.salvataggioInCorso = false
          return
        }        
        try {
          let itm = this.locDocumento
          errorService.onInfo(JSON.stringify(itm))
          var result
          if (!itm._id) {

            const numeratore = itm.tipoDocumento.numeratore
            const annoRiferimento = getAnnoRiferimento(itm.data) // itm.data.getFullYear()
            const numero = await configurazioni.getNumeratore(numeratore, true, annoRiferimento)
            itm._id = numero
            itm.codice = numero
/*             const newItm = JSON.parse(JSON.stringify(this.locDocumento))
            delete newItm.appoggio
            result = await documenti.creaDocumento(newItm) */

            result = await documenti.creaDocumento(itm)
            // Verifica se va creato il movimento relativo          
            // await this.verificaAggiungiMovimenti(result)
          } else {
/*             const newItm = JSON.parse(JSON.stringify(this.locDocumento))
            delete newItm.appoggio
            if (_.get(newItm, 'stato.codice', '') === 'daVerificare') {
              newItm.stato = this.statoNullo
            }
            result = await documenti.aggiornaDocumento(itm)
            // Verifica se va aggiornato il movimento relativo
            await this.verificaModificaMovimenti(result) */
/*             if (_.get(itm, 'stato.codice', '') === 'daVerificare') {
              itm.stato = this.statoNullo
            } */
            result = await documenti.aggiornaDocumento(itm)
            // await this.verificaModificaMovimenti(result)            
          }

          // FIXME: workaround per continuare a leggere la giacenza del prodotto. Verificare completamente. Problemi anche se cambiano le righe
          for (let i = 0; i < result.righe.length; i++) {
            if (itm.righe[i]) {
              result.righe[i].appoggio = itm.righe[i].appoggio
            } else {
              result.righe[i].appoggio = {}
            }
          }
          this.locDocumento = result
          this.completaAppoggio()
          this.trigger++
          await this.$nextTick()
          this.daSalvare = false
          this.salvataggioInCorso = false
          return result        
        } catch (error) {
          errorService.onError(error, 'editDocumento.salvaDocumento')
          this.salvataggioInCorso = false
        } 
      },
      async creaOrdiniFornitore() {
        this.dialogCreaOrdiniConfirm = true
      },
      async salvaXML() {
        if (this.daSalvare) {
          await this.salvaDocumento()
        }
        await this.generaXmlItem(this.locDocumento._id)
      },
      closeDialogDocumento() {
        if (!this.saveDisabled) {
          this.dialogCloseConfirm = true
        } else {
          this.closeDialog()
        }
      },
      closeConfirm() {
        this.dialogCloseConfirm = false
        this.closeDialog()
      },
      cancelClose() {
        this.dialogCloseConfirm = false
      },
      closeDialog() {
        this.locDocumento = { model: '', generale: '', source: '', tipoDocumento: { codice: null } }
        this.dialogDettaglioDocumento = false
        this.$emit('refresh')
      },
      async creaConfirm() {
        this.dialogCreaOrdiniConfirm = false
        this.creazioneInCorso = true
        /*
          1) Marca le singole righe come inviate (per modifiche fatte successivamente)
          2) genera un orgine per ciascun fornitore
        */
       this.elencoOrdiniCreati = ''
        const righe = this.locDocumento.righe
        if (righe.length === 0) return
        const fornitori = []
        for (let r of righe) {
          const f = r.prodotto.fornitore
          if (!fornitori.find(x => x === f.codice)) {
            fornitori.push(f.codice)
          }
        }
        const tipi = await configurazioni.getConfigurazione('documenti_parametri', 'tipiDocumento')
        const tipoDocumento = tipi.find(x => x.tipoDocumento === 'ordineFornitore')
        for (let f of fornitori) {
          const fornitore = await clienti.getCliente(f)
          let righe = this.locDocumento.righe.filter(x => x.prodotto.fornitore.codice === f && !x.ordineMultiplo) // Non condidera le righe già considerate su altri ordini
          let ordine = await documenti.getModello('xxx')
          ordine.data = new Date()
          
          ordine.tipoDocumento = { ...tipoDocumento }
          _.set(ordine, 'trasforma.sorgente', this.locDocumento.codice) // L'ordine fornitore deriva da un ordine multiplo --> verificare come gestire la relazione opposta
          _.set(ordine, 'anagrafica.fornitore', fornitore)
          ordine.righe = [...righe]
          const numeratore = tipoDocumento.numeratore
          const annoRiferimento = getAnnoRiferimento(ordine.data)
          const numero = await configurazioni.getNumeratore(numeratore, true, annoRiferimento)
          ordine._id = numero
          ordine.codice = numero
          let result = await documenti.creaDocumento(ordine)
          // console.log('Creato ordine: ', result._id)
          
          this.elencoOrdiniCreati += `${this.elencoOrdiniCreati.length > 0 ? '; ' : ''}` + result._id
          for (let r of righe) {
            r.ordineMultiplo = {
              codice: ordine._id,
              data: ordine.data
            }
          }
        }
        this.locDocumento.stato = { codice: 'ordiniCreati', descrizione: 'Ordini creati' }
        await this.salvaDocumento()
        this.creazioneInCorso = false
        this.creazioneDisabled = true
        this.ordiniCreati = true        
      },
      creaCancel() {
        this.dialogCreaOrdiniConfirm = false
      },

      async verificaAggiungiMovimenti(documento) {
        // Verificare altri tipi di documento
        if (!['fatturaImmediata', 'ddt', 'ddtFornitore'].includes(documento.tipoDocumento.codice)) return
        const prodotti = documento.righe.filter(x => x.prodotto && x.prodotto.codice)
        const modello = await movimenti.getModello('xxx')
        let numErrori = 0
        for (const p of prodotti) {
          let movimento = JSON.parse(JSON.stringify(modello))
          movimento.data = documento.data || new Date()
          movimento.magazzino = documento.magazzino
          movimento.prodotto = {
            codice: p.prodotto.codice,
            lotti: [],
            um: p.unitaMisura,
            quantita: +parseFloat(p.quantita).toFixed(2)
          }
          movimento.quantita = +parseFloat(p.quantita).toFixed(2)
          // movimento.valore = +parseFloat(p.valore.importoTotale).toFixed(2)
          // TODO: Verificare (probabilemente non chiamato perchè solo ordine a fornitore)
          movimento.valore = _.get(p, 'valore.listino.ivato', true) ? +parseFloat(p.valore.importoTotale).toFixed(2) : +parseFloat(p.valore.importoNettoTotale).toFixed(2) 
          movimento.causale = documento.tipoDocumento.causale
          if (documento.tipoDocumento.codice === 'ddtFornitore') {
            movimento.anagrafica = {
              cliente: '',
              fornitore: documento.anagrafica.fornitore
            }
          } else {
            movimento.anagrafica = {
              cliente: documento.anagrafica.cliente,
              fornitore: ''
            }
          }
          movimento.riferimento = {
            tipo: 'documento',
            id: documento.codice,
            data: documento.data
          }
          if (!await magazzino.creaMovimenti(movimento)) {
            numErrori++
          }
        }

      },
      async verificaModificaMovimenti(documento) {
        if (!['fatturaImmediata', 'ddt', 'ddtFornitore'].includes(documento.tipoDocumento.codice)) return
        await magazzino.cancellaPerRiferimento('documento', documento.codice, documento.data)
        await this.verificaAggiungiMovimenti(documento)
      }
    }
  }
</script>